import React from 'react';

const WalletConnect = ({ onWalletConnected }) => {
  return (
    <div className="wallet-connect">
      <button 
        className="btn btn-outline-primary btn-sm"
        onClick={() => onWalletConnected('0x71C7656EC7ab88b098defB751B7401B5f6d8976F')}
      >
        Conectar Wallet (Simulado)
      </button>
      <p className="text-muted small mt-2">
        Nota: En versión de pruebas, esto usa una dirección simulada.
      </p>
    </div>
  );
};

export default WalletConnect;
